import Vue from 'vue'
import Vuex from 'vuex'
import storage from 'store'
import { getInfo } from '../api/manage'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: '',
    includeArr: [],
    popData: {
      slotData: null,
      showPop: false
    },
    transitionName: 'slide-left',
    tableBoxDatas: {
      show: false,
      widthObj: {},
      thDatas: {},
      tdDatas: []
    },
    modulename: 'uganda',
    userMenu: []
  },
  mutations: {
    OPEN_TABLEBOX_DATAS: (state, datas) => {
      Object.assign(state.tableBoxDatas, datas);
      state.tableBoxDatas.show = true;
    },
    CLOSE_TABLEBOX_DATAS: (state) => {
      state.tableBoxDatas.show = false;
    },
    SET_INFO: (state, info) => {
      state.userInfo = info
    },
    addInclude: (state, info) => {
      state.includeArr.push(info);
    },
    delInclude: (state, info) => {
      state.includeArr.splice(state.includeArr.indexOf(info), 1);
    },
    setPopSlot: (state, slotData) => {
      state.popData.showPop = true
      state.popData.slotData = slotData
    },
    deletePopSlot: (state) => {
      state.popData.showPop = false
      // state.popData.slotData = null
    },
    setTranstion: (state, data) => {
      state.transitionName = data
    },
    setUserMenu: (state, data) => {
      state.userMenu = data;
    }
  },
  actions: {
    OPEN_TABLEBOX_DATAS: ({ commit }, datas) => {
      commit('OPEN_TABLEBOX_DATAS', datas);
    },
    CLOSE_TABLEBOX_DATAS: ({ commit }) => {
      commit('CLOSE_TABLEBOX_DATAS');
    },
    setPopSlot: ({ commit }, data) => {
      commit('setPopSlot', data)
    },
    deletePopSlot: ({ commit }) => {
      commit('deletePopSlot')
    },
    setTranstion: ({ commit }, data) => {
      commit('setTranstion', data)
    },
    // 登出
    Logout: () => {
      storage.remove('Access-Token')
      storage.clearAll();
      return location.reload();
    },
    getInfo: ({ commit }) => {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res) => {
            commit('SET_INFO', res)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    addInclude: ({ commit, state }, data) => {
      if(!state.includeArr.includes(data)){
        commit('addInclude', data)
      }
    },
    delInclude: ({ commit }, data) => {
      commit('delInclude', data)
    },
    setUserMenu: ({ commit }, data) => {
      commit('setUserMenu', data)
    }
  },
  modules: {},
})
